import React from 'react';
import { Box, Button } from '@mui/material';

interface FooterProps {
  onSave: () => void;
  onCancel: () => void;
  disabled: boolean;
}

export function Footer({ onSave, onCancel, disabled }: FooterProps) {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'flex-end', 
      pt: 1,
      gap: 2,
      borderTop: '1px solid rgba(0, 0, 0, 0.12)'
    }}>
      <Button 
        variant="outlined" 
        color="primary"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button 
        variant="contained" 
        color="primary"
        disabled={disabled}
        onClick={onSave}
      >
        Save
      </Button>
    </Box>
  );
} 